import { useContractKit } from '@celo-tools/use-contractkit'
import { Link, useHistory } from 'react-router-dom'

import { Button, Card } from '../../components'
import { AddMetamask } from '../../components/add-metamask'
import { PlatformStats } from '../../components/platform-stats/platform-stats'
import { Paths } from '../../config/routes'

export function ValidatorDashboard() {
    const history = useHistory()
    const { address: payableAddress } = useContractKit()

    return (
        <div className='grid h-full grid-cols-8 gap-4 py-4 grid-rows-8'>
            <div className='col-span-8 xl:col-span-6'>
                <Card className='w-full h-full px-12'>
                    {payableAddress ? (
                        <div className='flex flex-col justify-center w-4/5 h-full'>
                            <h1 className='text-3xl font-semibold'>
                                Review loans
                            </h1>
                            <p className='font-light text-black'>
                                You can now review loans on the Masa protocol
                                and earn rewards for validating financial data
                            </p>
                            <Link to={Paths.LOAN_APPLICATIONS}>
                                <Button className='py-4 mt-2 w-max'>
                                    + Review loans
                                </Button>
                            </Link>
                        </div>
                    ) : (
                        <div className='flex flex-col justify-center w-4/5 h-full'>
                            <h1 className='text-3xl font-semibold'>
                                Complete registration
                            </h1>
                            <p className='font-light text-black'>
                                You must connect your wallet and stake Masa
                                tokens to be able to validate financial data and
                                underwrite loans
                            </p>
                            <AddMetamask
                                saveOnAccount
                                type='button'
                                text='+ Connect Metamask'
                                className='flex flex-row px-4 py-4 w-max'
                            />
                        </div>
                    )}
                </Card>
            </div>
            <div className='col-span-8 row-start-4 xl:row-span-2 xl:col-span-2'>
                <Card className='w-full'>
                    <PlatformStats />
                </Card>
            </div>
            <div className='col-span-2'>
                <Card className='flex flex-col items-center w-full '>
                    <h3>Protocol Validators</h3>
                    <h1 className='my-4 text-5xl'>17</h1>
                    <p className='font-semibold text-black'>Active</p>
                    <AddMetamask
                        type='white'
                        onActiveText={'Stake to validate (coming soon)'}
                        onActiveClick={() => history.push(Paths.STAKE)}
                        disabled={true}
                    />
                </Card>
            </div>
            <div className='col-span-2'>
                <Card className='flex flex-col items-center w-full'>
                    <h3>Loan Applications</h3>
                    <h1 className='my-4 text-5xl'>3</h1>
                    <p className='font-semibold text-black'>Applications</p>
                    <AddMetamask
                        type='white'
                        onActiveText={'Stake to approve (coming soon)'}
                        onActiveClick={() => history.push(Paths.STAKE)}
                        disabled={true}
                    />
                </Card>
            </div>
            <div className='col-span-2'>
                <Card className='flex flex-col items-center justify-between w-full h-full xl:h-auto'>
                    <h3>Active Loans</h3>
                    <h1 className='my-4 text-5xl'>0</h1>
                    <div className='text-center'>
                        <p className='font-semibold text-black'>Active</p>
                        <AddMetamask
                            type='white'
                            onActiveText={'Stake to approve (coming soon)'}
                            onActiveClick={() => history.push(Paths.STAKE)}
                            disabled={true}
                        />
                    </div>
                </Card>
            </div>
        </div>
    )
}
